module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAALVBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMNHj8edxOHz+Pv///+Ftdrn8PiRvN2gisSZAAAAB3RSTlMAYL8AIM/vi50ITwAAALtJREFUeF7t1iEZQgEMAOFlwKBRBBgk4CMBdEA/xBtZqEIGipACcX43D6f/ABcRm2rbZUaeS7pmHG6G1lMcS7vE1tESe0f3qEE/jB49wjx7hHn1CCMIIwgjCNMgjCCMIIwgTIMwgjCCMIIwDcIIwgjCCMI0CCMIIwhjCCPobQhlCGUIZQhlCGUIZQhlCGUIZQhlCGUIZQhlCGUIZQhlCGUIZQhlCCWIPoroj2g0NKM1Gk3WaNdm45fpC/kFMH4xdZ2F2rEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/25c0.png
// module id = 1337
// module chunks = 0